import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../redux/actions';

export function useCustomers() {
  const dispatch = useDispatch();
  const customerRows = useSelector((state) => state.customer?.rows) || [];

  useEffect(() => {
    dispatch(actions.customerAll({ size: 1000 }));
  }, [dispatch]);

  const findCustomer = (id) => customerRows.find((c) => c._id === id);
  const customerName = (id) => findCustomer(id)?.name || id;

  return { customerRows, findCustomer, customerName };
}

export default useCustomers;
